var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"link"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"/news"}},[_vm._v("最新情報")])]),_c('li',[_c('a',{attrs:{"href":"/company"}},[_vm._v("会社概要")])])])])]),_c('div',{staticClass:"copy-right"},[_c('p',[_vm._v("Copyright(C) 永源寺きのこセンター All right reserved.")])])])
}]

export { render, staticRenderFns }